import type { FC } from "react";
import { InlineMessage } from "@volvo/vcdk-react";
import log from "../../../logging/logger";
import styles from "./NonProdMessage.module.css";

interface NonProdMessageProps {
    setEnvMessageVisible: (visible: boolean) => void;
}

const NonProdMessage: FC<NonProdMessageProps> = ({ setEnvMessageVisible }) => {
    return (
        <div className={styles.NonProdMessageContainer}>
            <InlineMessage
                heading="Do not upload, process, or store any production or personally identifiable data - non-production environment."
                variant="warning"
                closable={true}
                icon="warning"
                ref={(e) => {
                    log.trace(e?.variant);
                }}
                onClick={(e) => {
                    log.trace(e.detail);
                }}
                onClose={(e) => {
                    log.debug("NonProdMessage closed", e);
                    setEnvMessageVisible(false);
                }}
            ></InlineMessage>
        </div>
    );
};
export default NonProdMessage;
